export const questions = {
  "gameType": "MonthlyBonus",
  "glo": [
  ]
}